(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["academy-guide-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Delegated from the document, so a band the theme editor re-renders needs no re-binding,
       and two instances on one page never share state. */

    /* Fires on a real 200, before the module shows the panel and before any reset, so the form
       still holds what was sent. Text only: the address is the reader's input. */
    document.addEventListener('cohr:submitted', function (event) {
      const form = event.target;
      if (!form.matches || !form.matches('[data-academy-guide-form]')) return;
      const panel = document.getElementById(form.dataset.cohrSuccessPanel);
      const echo = panel && panel.querySelector('[data-academy-guide-echo]');
      const email = form.elements.namedItem('email');
      if (echo && email) echo.textContent = email.value.trim();
    });

    /* The panel path never resets the form, so bringing it back is this section's job. */
    document.addEventListener('click', function (event) {
      const again = event.target.closest && event.target.closest('[data-academy-guide-again]');
      if (!again) return;
      const panel = again.closest('.academy-guide__done');
      const form = panel && document.querySelector('[data-cohr-success-panel="' + panel.id + '"]');
      if (!form) return;

      form.reset();
      panel.hidden = true;
      form.hidden = false;
      const email = form.elements.namedItem('email');
      if (email) email.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["academy-hero-carousel"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-academy-carousel]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (!slides.length) return;

      var segments = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
      var whens = Array.prototype.slice.call(root.querySelectorAll('[data-when]'));
      var previous = root.querySelector('.academy-hero-carousel__arrow--prev');
      var next = root.querySelector('.academy-hero-carousel__arrow--next');

      /* The flag every hiding rule and the rail itself are gated on. Set before anything else,
         so a single-academy page still collapses to one slide and shows no rail. */
      root.setAttribute('data-academy-carousel-enhanced', '');

      if (slides.length < 2) return;

      var index = 0;

      function activeFill() {
        return segments[index].querySelector('.academy-hero-carousel__segment-fill');
      }

      /* Restarts the active segment's fill from zero. The class move below already restarts the
         animation on a segment that was not active, but not on one that was — clicking the
         current segment has to reset its own countdown rather than do nothing. Assigning `none`,
         forcing a reflow so the removal is actually observed, then handing the property back to
         the stylesheet is the only way to replay a CSS animation.

         Under prefers-reduced-motion the stylesheet's `animation: none` is what it is handed back
         to, so this restarts nothing and nothing advances. That is the reduced case, still
         declared in exactly one place. */
      function restartFill() {
        var fill = activeFill();
        if (!fill) return;
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      function show(n) {
        index = (n + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });

        /* The phone's single label. Hidden at desktop width by the stylesheet, so this runs
           either way and the media query decides whether it is seen. */
        whens.forEach(function (when, i) {
          when.classList.toggle('is-active', i === index);
        });

        segments.forEach(function (segment, i) {
          segment.classList.toggle('is-active', i === index);
          segment.classList.toggle('is-done', i < index);
          if (i === index) {
            segment.setAttribute('aria-current', 'true');
          } else {
            segment.removeAttribute('aria-current');
          }
        });

        restartFill();
      }

      /* The one clock. The gold fill runs for the interval the stylesheet declares, and its end
         is what advances the slide — so the bar a reader is watching cannot disagree with the
         moment the slide changes, because they are the same event. Hover and keyboard focus pause
         the fill in CSS, which pauses the advance with it and resumes both with the same time
         left. There is no second timer, and nothing here reads the interval. */
      root.addEventListener('animationend', function (event) {
        if (event.animationName !== 'academy-hero-fill') return;
        if (event.target !== activeFill()) return;
        show(index + 1);
      });

      segments.forEach(function (segment) {
        segment.addEventListener('click', function () {
          show(parseInt(segment.getAttribute('data-go'), 10) || 0);
        });
      });

      /* Wraps at both ends rather than disabling an arrow, as both kits do: an arrow that
         changes meaning as you page is worse than one that always does the same thing. */
      if (previous) {
        previous.addEventListener('click', function () {
          show(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }

      /* No pause listeners, and no kick-off call. Hover and keyboard focus are handled entirely by
         the stylesheet's `animation-play-state`, and the first slide's fill is already running
         from the `is-active` class the markup ships — the rail becomes visible the moment the flag
         above is set, and a fill that is displayed is a fill that has started. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["academy-hero-single"]) return;
  try {
    
  (function () {
    const enhanced = new WeakSet();

    function enhance(host) {
      if (enhanced.has(host)) return;
      enhanced.add(host);

      const button = host.querySelector('button');
      if (!button) return;

      /* button.liquid puts the visible text in `.button__label`. The same deliberate coupling
         `dialog.liquid` and `form-submit.liquid` make, and for the same reason: a bare button
         here would be a second button dialect in the theme. */
      const label = button.querySelector('.button__label') || button;
      const resting = label.textContent;
      let busy = false;

      /* The button ships `disabled` from Liquid and this is what turns it on, so the live button
         and the working module arrive together and cannot get out of step. */
      button.disabled = false;

      function settle() {
        busy = false;
        button.disabled = false;
        label.textContent = resting;
        host.removeAttribute('aria-busy');
      }

      /* Every failure route ends here. 🚨 The button is usable again BEFORE the message is
         fired, not after: a reader who has just been told an academy filled has nothing to do
         next but press it again, and a button left spinning behind a toast is the exact failure
         the ticket names. */
      function fail(message) {
        settle();
        if (window.cohr && window.cohr.toast && message) {
          window.cohr.toast({ message: message, tone: 'danger' });
        }
      }

      /* Has the reader declared they NEED the L3? The shelf's checkbox, found through the card
         rather than held in a variable, because the fee swap below owns that element and two
         closures tracking one control is two things to keep in step.

         A missing checkbox reads as unticked, which is the served page's own default and the
         fee the card is showing: Liquid renders `data-discount-code` and the shelf on one
         boolean, so this is the impossible branch rather than a fallback. */
      function declared(wrapper) {
        const card = wrapper.closest('.academy-hero-single');
        const shelf = card && card.querySelector('[data-cohr-l3] input[type="checkbox"]');
        /* 🚨 A DISABLED SWITCH NEVER DECLARES (#274). Past the Movement Foundations cut-off it
           renders disabled and unticked, and nothing in the theme ticks it — but a browser
           restoring form state is not the theme, and a ticked closed switch would send `''` and
           charge a fee this academy no longer sells. Closed always books with the code. */
        return !!(shelf && shelf.checked && !shelf.disabled);
      }

      /* Asked only when the basket holds a different academy and more than one place — the
         module decides that, not this function. The copy carries two placeholders because a
         script block is not rendered through Liquid and cannot call `t` itself. */
      function confirmReplacement(cart) {
        const item = (cart.items && cart.items[0]) || {};
        const body = (host.dataset.confirmBody || '')
          .replace('%places%', String(cart.item_count))
          .replace('%academy%', item.product_title || '');

        return window.cohr
          .dialog({
            eyebrow: host.dataset.confirmEyebrow,
            title: host.dataset.confirmTitle,
            body: body,
            confirm: host.dataset.confirmYes,
            cancel: host.dataset.confirmNo
          })
          /* Tested for equality, never for truthiness: Escape, the close button and the scrim
             all resolve `null`, and a dismissal must never read as a confirmation. */
          .then(function (answer) {
            return answer === 'confirm';
          });
      }

      button.addEventListener('click', function () {
        /* A boolean rather than the button's own `disabled`, matching `form-submit.liquid`: a
           second click can be dispatched in the same turn as the first. */
        if (busy) return;

        /* The module and the two hosts are mounted in `layout/theme.liquid` and share one
           bundle, so this is all-or-nothing — there is no state where the cart module is missing
           and the toast host is there to report it. Nothing is written and nothing is claimed. */
        if (!window.cohr || !window.cohr.cart || !window.cohr.dialog) return;

        busy = true;
        button.disabled = true;
        if (host.dataset.busy) label.textContent = host.dataset.busy;
        host.setAttribute('aria-busy', 'true');

        const options = {
          cartJsUrl: host.dataset.cartJsUrl,
          clearUrl: host.dataset.clearUrl,
          addUrl: host.dataset.addUrl,
          updateUrl: host.dataset.updateUrl,
          id: host.dataset.variantId,
          quantity: 1,
          confirm: confirmReplacement
        };

        /* 🚨 THE DECLARATION, READ AT THE CLICK (#119). The switch posts nothing, so the code
           on the cart is the only record of it, and the polarity is the opposite of the usual
           one: UNTICKED — the Attendee already holds the L3 — is what sends the code. Ticked sends
           `''` and removes it.

           `discount` is set only when Liquid put the attribute there, which is only on an
           academy that carries the add-on and only once the code is typed into Theme settings.
           The key is otherwise absent, and `cart-transport` reads absent and `''` as different
           instructions — see its header. Nothing here reads `document.cookie`. */
        const code = host.dataset.discountCode;
        if (typeof code === 'string') {
          /* Read live rather than tracked, for the same reason the basket is: this is the
             reader's answer at the moment they pressed the button. */
          options.discount = declared(host) ? '' : code;
        }

        window.cohr.cart
          .book(options)
          .then(function (result) {
            /* Cancelled: the basket was never touched, and the reader is back where they were
               with the button live again. No toast — they know what they just chose. */
            if (result.outcome === 'cancelled') {
              settle();
              return;
            }

            /* Booked, or the basket was already holding this academy. Both land on the cart,
               which is the only route to it in this theme. The busy state is left as it is on
               purpose: the page is leaving, and restoring the resting label first would flash
               the button back to "Book this academy" under a reader who has already pressed it. */
            window.location = host.dataset.cartUrl;
          })
          .catch(function (error) {
            /* 🚨 CHECKED BEFORE THE STATUS, AND IT HAS NONE. The request succeeded and the
               cart came back without the declaration on it — a code misspelled in Theme
               settings, or deleted in admin. Nothing carries on to the cart: the page quoted a
               fee and the basket disagrees with it, and the one outcome forbidden here is
               reaching checkout charging something the reader was never shown. There is no
               retry and no re-apply behind their back; the button comes back live and pressing
               it asks again. */
            if (error && error.name === 'DiscountError') {
              fail(host.dataset.feeMismatch);
              return;
            }

            const status = error && error.status;
            /* Three failures, three sentences. A 422 is the race. It is handled because
               Shopify documents it, not because this store was seen to send one: measured at
               the Phase 5 gate, `/cart/add.js` accepted `quantity: 99` on a zero-inventory
               `deny` variant with a 200, so enforcement is at checkout (#65). Any other
               status is an unexpected response. No status at all is the network: `fetch` rejects
               with a TypeError that has none, and whose message ("Failed to fetch") is
               English-only and no use to a reader. */
            if (status === 422) {
              fail(host.dataset.soldOut);
            } else if (status) {
              fail(host.dataset.failed);
            } else {
              fail(host.dataset.offline);
            }
          });
      });
    }

    function init() {
      document.querySelectorAll('[data-cohr-book]').forEach(enhance);
    }

    init();
    /* The theme editor swaps a section's markup without reloading, which would otherwise leave
       the new button inert. */
    document.addEventListener('shopify:section:load', init);
  })();

  /* ─── THE ADD-ON SHELF'S FEE SWAP (#116) ──────────────────────────────────────────────────
     Its own closure, and not part of the booking module above, because the shelf renders at
     every stage and the booking module renders at exactly one. A shelf on a planned academy
     has no `[data-cohr-book]` wrapper anywhere near it.

     🚨 IT MOVES ONE ATTRIBUTE AND DOES NOTHING ELSE. Both fees are already in the DOM,
     formatted by `| money` — no arithmetic, no currency symbol, no separator and no decimal
     place is decided here. That is the entire reason `academy-price` is rendered twice.

     AND IT DOES NOT ANIMATE. Nothing on this site animates to draw attention to itself and a
     fee is the last thing that should (the 26 August veto on scroll reveals). There is no
     transition to write and so nothing for `prefers-reduced-motion` to catch.

     🚨 IT IS NOT DEAD CODE NOW `assets/l3-addon.js` EXISTS (#148), AND THE TWO CANNOT DISAGREE.

     The shared module owns the stored answer: it seeds this switch and swaps this fee pair on
     load, on a theme-editor section load, and when a second tab writes. This closure owns the
     *change*, which is the case the store cannot reach — a `storage` event fires in the other
     tabs, and setting `checked` in code fires no `change` at all. Both read the same one truth,
     the checkbox, and both write the same `hidden`, so running both is idempotent.

     The module runs first, always: the layout loads it above `content_for_header`, and deferred
     scripts execute in document order. `sync()` below is therefore reconciling against a switch
     the store has already seeded, which is the same job it was written for — the browser's own
     restored checkbox is the other thing it catches. */
  (function () {
    const enhanced = new WeakSet();

    function enhance(host) {
      if (enhanced.has(host)) return;
      enhanced.add(host);

      /* By element rather than by `.switch__input`: the shelf owns exactly one checkbox, and
         this way the swap does not couple itself to `form-switch`'s internal class names. */
      const input = host.querySelector('input[type="checkbox"]');
      const root = host.closest('.academy-hero-single');
      if (!input || !root) return;

      const held = root.querySelector('[data-l3="held"]');
      const needed = root.querySelector('[data-l3="needed"]');
      /* Liquid gates the shelf and the second fee block on one boolean, so neither can be
         missing while the other is here. Checked anyway: a swap against a null is a thrown
         TypeError, and it would take the booking module's `shopify:section:load` with it. */
      if (!held || !needed) return;

      function sync() {
        held.hidden = input.checked;
        needed.hidden = !input.checked;
      }

      input.addEventListener('change', sync);

      /* 🚨 Read once at startup, never assumed. A browser restores a checkbox's state across a
         reload and across a back-navigation, so the box can already be ticked by the time this
         runs while Liquid's served markup still shows the held fee. Without this the page would
         say £1,699 under a ticked switch. */
      sync();
    }

    function init() {
      document.querySelectorAll('[data-cohr-l3]').forEach(enhance);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["academy-tabs"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-academy-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

      /* No tabs is a section rendered without its row — nothing to enhance, and the panels are
         already readable. Leaving the flag off is what keeps them that way. */
      if (tabs.length < 2 || !panels.length) return;

      root.setAttribute('data-academy-tabs-enhanced', '');

      function select(value, moveFocus) {
        tabs.forEach(function (tab) {
          var active = tab.getAttribute('data-tab') === value;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-panel') === value);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab.getAttribute('data-tab'), false);
        });

        tab.addEventListener('keydown', function (event) {
          var next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = tabs[(index + 1) % tabs.length];
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = tabs[(index - 1 + tabs.length) % tabs.length];
          } else if (event.key === 'Home') {
            next = tabs[0];
          } else if (event.key === 'End') {
            next = tabs[tabs.length - 1];
          }

          if (!next) return;

          /* The arrow keys are navigation, not scrolling, once focus is on the row. */
          event.preventDefault();
          select(next.getAttribute('data-tab'), true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const enhanced = new WeakSet();

    /* The four control shells that can carry an --invalid variant. `closest` matches the element
       itself, so a textarea — a single element rather than a wrapper plus a control — is found by
       the same call as an input. `checkbox` is the terms box, and is why this list is one longer
       than `form-submit.liquid`'s. */
    const SHELLS = ['input', 'select', 'textarea', 'checkbox'];

    function shellOf(control) {
      for (let i = 0; i < SHELLS.length; i++) {
        const found = control.closest('.' + SHELLS[i]);
        if (found) return { element: found, base: SHELLS[i] };
      }
      return null;
    }

    /* Everything the browser will validate. The multi-place switch is in here and is never
       required, which costs nothing; it has no name, so it is not in the payload either. */
    function validatable(form) {
      return Array.prototype.filter.call(form.elements, function (element) {
        return element.willValidate && element.type !== 'hidden' && element.type !== 'submit';
      });
    }

    function enhance(form) {
      if (enhanced.has(form)) return;
      enhanced.add(form);

      const root = form.closest('.cart');
      if (!root) return;

      const places = document.getElementById(form.dataset.placesControl);
      const toggle = document.getElementById(form.dataset.placesToggle);
      const field = places ? places.closest('.form-field') : null;
      /* The shell, because `form-select` paints the disabled state on the wrapper and not on the
         control. See the markup above: the class comes off with the attribute or neither does. */
      const placesShell = places ? places.closest('.select') : null;
      const terms = document.getElementById(form.dataset.termsControl);
      const email = document.getElementById(form.dataset.emailControl);
      const change = root.querySelector('[data-cohr-change]');
      const submits = root.querySelectorAll('.cart__submit');

      let busy = false;

      function labelOf(button) {
        /* button.liquid puts the visible text in `.button__label` — the same deliberate coupling
           `dialog`, `form-submit` and the Book button all make. */
        return button.querySelector('.button__label') || button;
      }

      const resting = [];
      Array.prototype.forEach.call(submits, function (button) {
        resting.push(labelOf(button).textContent);
      });

      /* Both submits ship `disabled` from Liquid and this is what turns them on, so the live
         buttons and the working module arrive together. This is NOT the terms gate — Confirm and
         pay stays enabled with the box unticked, and says why on the attempt. */
      function activate() {
        Array.prototype.forEach.call(submits, function (button) {
          button.disabled = false;
        });
      }

      function settle() {
        busy = false;
        Array.prototype.forEach.call(submits, function (button, index) {
          button.disabled = false;
          labelOf(button).textContent = resting[index];
        });
        form.removeAttribute('aria-busy');
      }

      /* Every failure route ends here. 🚨 The buttons are usable again BEFORE the message is
         fired, not after: a reader who has just been told an academy filled has nothing to do
         next but try again, and a button left spinning behind a toast is the failure #58 named. */
      function fail(message) {
        settle();
        if (window.cohr && window.cohr.toast && message) {
          window.cohr.toast({ message: message, tone: 'danger' });
        }
      }

      /* How many places the reader is asking for. A disabled selector is not asking for anything
         — the toggle is off and the answer is one. */
      function wanted() {
        if (!places || places.disabled) return 1;
        return Number(places.value) || 1;
      }

      /* Every total was drawn by Liquid; this only chooses which one is showing. See the section
         header for why the money is not formatted here. */
      function draw() {
        const count = wanted();

        root.querySelectorAll('[data-cohr-for-places]').forEach(function (element) {
          element.hidden = Number(element.dataset.cohrForPlaces) !== count;
        });

        const copy = root.querySelector('[data-cohr-count-copy]');
        if (!copy) return;

        const title = copy.querySelector('.section-heading__title');
        const lede = copy.querySelector('.section-heading__lede');
        const many = count > 1;

        if (title) title.textContent = many ? copy.dataset.titleMany : copy.dataset.titleOne;
        if (lede) {
          lede.textContent = (many ? copy.dataset.ledeMany : copy.dataset.ledeOne).replace(
            '%count%',
            String(count)
          );
        }
      }

      function markField(control, message) {
        const shell = shellOf(control);
        if (shell) shell.element.classList.toggle(shell.base + '--invalid', Boolean(message));

        if (message) {
          control.setAttribute('aria-invalid', 'true');
        } else {
          control.removeAttribute('aria-invalid');
        }

        const slot = document.getElementById(control.id + '-error');
        if (slot) {
          slot.textContent = message || '';
          slot.hidden = !message;
        }

        /* An error replaces the hint — two lines of guidance under a failed field is noise at the
           moment the reader has least patience for it. `form-field`'s rule, kept here. */
        const hint = document.getElementById(control.id + '-hint');
        if (hint) hint.hidden = Boolean(message);
      }

      /* Our own words where we have them, the browser's where we do not. The terms box gets its
         own sentence: "This one is needed before we can send it" is true of a surname and wrong
         about an agreement. */
      function messageOf(control) {
        if (terms && control === terms) return form.dataset.termsError;
        if (control.validity.valueMissing && form.dataset.missing) return form.dataset.missing;
        if (
          control.validity.typeMismatch &&
          control.type === 'email' &&
          form.dataset.invalidEmail
        ) {
          return form.dataset.invalidEmail;
        }
        return control.validationMessage;
      }

      function clear() {
        validatable(form).forEach(function (control) {
          markField(control, '');
        });
      }

      function send() {
        busy = true;

        Array.prototype.forEach.call(submits, function (button) {
          button.disabled = true;
          if (form.dataset.busy) labelOf(button).textContent = form.dataset.busy;
        });
        form.setAttribute('aria-busy', 'true');

        /* Liquid owns the attribute keys — they are on the controls' `name`s — so nothing here
           knows or spells one. An empty optional field sends an empty string, which is how
           Shopify removes an attribute: a phone number deleted on a second pass has to actually
           leave the record. The terms box is simply absent when unticked, and that absence is
           the record (`handoff/TERMS.md`). */
        const attributes = {};
        new FormData(form).forEach(function (value, key) {
          const match = /^attributes\[(.+)\]$/.exec(key);
          if (match) attributes[match[1]] = String(value).trim();
        });

        const count = wanted();
        const updates = {};
        updates[form.dataset.variantId] = count;

        window.cohr.cart
          .post(form.dataset.updateUrl, { updates: updates, attributes: attributes })
          .then(function (cart) {
            const items = (cart && cart.items) || [];
            let line = null;
            for (let i = 0; i < items.length; i++) {
              if (String(items[i].id) === String(form.dataset.variantId)) line = items[i];
            }

            /* 🚨 The race. Overselling is denied, so places can go between the page loading and
               this request — and `/cart/update.js` answers a request past the ceiling by clamping
               the quantity rather than refusing it. A 200 is therefore not proof the basket holds
               what was asked for, and redirecting on one would send a Sponsor to pay for two
               places having asked for four. The selector is put back to what the basket actually
               holds so the totals stop claiming otherwise. */
            if (!line || line.quantity !== count) {
              if (places && line) places.value = String(line.quantity);
              draw();
              fail(form.dataset.soldOut);
              return;
            }

            /* 🚨 THE DECLARATION, CARRIED INTO CHECKOUT — see the section header for the
               measurement. A resumed checkout re-applies a code the cart no longer holds, so the
               cart states its position on every handoff instead of staying silent. Read from the
               response, which IS the cart, so no fourth request is made to ask.

               `applicable` is the test, exactly as `cart-transport`'s `holdsAny` uses it: an inert
               leftover is not charging anything and must not be re-asserted into the URL. An empty
               list yields `discount=`, and that empty value is the instruction that clears a
               resumed checkout — it is not a missing parameter and must not be optimised away. */
            const applicable = ((cart && cart.discount_codes) || [])
              .filter(function (entry) {
                return entry && entry.applicable;
              })
              .map(function (entry) {
                return entry.code;
              });

            const params = ['discount=' + encodeURIComponent(applicable.join(','))];

            /* The prefill is a nicety, not the mechanism — some checkout configurations ignore
               it, and the address is on the order as an attribute either way (§6.2). */
            const address = email ? email.value.trim() : '';
            if (address) params.push('checkout[email]=' + encodeURIComponent(address));

            const url = form.dataset.checkoutUrl + '?' + params.join('&');

            /* The busy state is left as it is on purpose: the page is leaving, and restoring the
               resting label first would flash the button back under a reader who has already
               pressed it. */
            window.location = url;
          })
          .catch(function (error) {
            const status = error && error.status;
            /* Three failures, three sentences — the same three the Book button tells apart. No
               status at all is the network: `fetch` rejects with a TypeError that has none, and
               whose message ("Failed to fetch") is English-only and no use to a reader. */
            if (status === 422) {
              fail(form.dataset.soldOut);
            } else if (status) {
              fail(form.dataset.failed);
            } else {
              fail(form.dataset.offline);
            }
          });
      }

      /* The switch listener goes on the switch, not on the form (`CONVENTIONS.md` §10.10): it
         runs in the target phase, before anything listening on the form, so `disabled` is already
         correct by the time anything else recomputes. */
      if (toggle) {
        toggle.addEventListener('change', function () {
          const on = toggle.checked;
          if (places) {
            places.disabled = !on;
            /* Switching it off is switching back to one place, which is what the design does and
               what the total then has to say. */
            if (!on) places.value = '1';
          }
          /* Both halves, always together. The attribute is what takes the control out of the
             form; the class is what says so on screen, and a revealed field still carrying it is
             a usable control drawn as an unusable one. */
          if (placesShell) placesShell.classList.toggle('select--disabled', !on);
          if (field) field.hidden = !on;
          draw();
        });
      }

      if (places) places.addEventListener('change', draw);

      /* 🚨 The destructive link, and the one guard on it. `data-places` is what the **basket**
         holds, not what the selector currently reads: a quantity chosen but never submitted is
         not held by anything and discards nothing. See `REDESIGN-PLAN.md` §6 and #58. */
      if (change) {
        const link = change.querySelector('a');
        if (link) {
          link.addEventListener('click', function (event) {
            const held = Number(change.dataset.places) || 1;
            if (held <= 1) return;
            if (!window.cohr || !window.cohr.dialog) return;

            event.preventDefault();

            const body = (change.dataset.body || '')
              .replace('%places%', String(held))
              .replace('%academy%', change.dataset.academy || '');

            window.cohr
              .dialog({
                eyebrow: change.dataset.eyebrow,
                title: change.dataset.title,
                body: body,
                confirm: change.dataset.confirm,
                cancel: change.dataset.cancel
              })
              /* Tested for equality, never for truthiness: Escape, the close button and the scrim
                 all resolve `null`, and a dismissal must never read as a confirmation. */
              .then(function (answer) {
                if (answer === 'confirm') window.location = link.href;
              });
          });
        }
      }

      form.addEventListener('submit', function (event) {
        /* Always, whichever button dispatched it — the in-page one or the pinned bar's, which is
           associated with this form by id and therefore lands here. One gate, and the bar calls
           it rather than keeping its own (`handoff/TERMS.md`). */
        event.preventDefault();

        /* A boolean rather than the buttons' `disabled`, matching `form-submit.liquid`: a second
           submit can be dispatched in the same turn as the first. */
        if (busy) return;

        /* The module and the two hosts are mounted in `layout/theme.liquid` and share one bundle,
           so this is all-or-nothing. Nothing is written and nothing is claimed. */
        if (!window.cohr || !window.cohr.cart) return;

        clear();

        const failures = [];
        validatable(form).forEach(function (control) {
          if (control.checkValidity()) return;
          const message = messageOf(control);
          markField(control, message);
          failures.push(control);
        });

        if (failures.length) {
          /* Focus the first thing that failed, in document order. The terms box is last, so when
             it is the only failure the focus lands there — which is what `handoff/TERMS.md` asks
             for and what the component deliberately does not do for you. The box's own ring may
             not paint on a pointer-driven attempt (`:focus-visible` is the browser's judgement,
             not ours); the red square and the sentence under it are what a sighted reader sees,
             and they are drawn either way. */
          failures[0].focus();
          return;
        }

        send();
      });

      activate();
      draw();
    }

    function init() {
      document.querySelectorAll('form[data-cohr-cart]').forEach(enhance);
    }

    init();
    /* The theme editor swaps a section's markup without reloading, which would otherwise leave
       the new form inert. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-onboarding"]) return;
  try {
    
  (function () {
    const enhanced = new WeakSet();

    /* Every control shell that can carry an `--invalid` variant. `closest` matches the element
       itself, so a textarea — one element rather than a wrapper plus a control — is found by the
       same call as an input. Mirrors `form-submit`'s own list. */
    const SHELLS = ['input', 'select', 'textarea'];

    function attendee() {
      let value;
      try {
        value = new URLSearchParams(window.location.search).get('attendee');
      } catch (error) {
        return false;
      }
      return value === 'true';
    }

    /* Clearing a field on the way out. The control cannot be invalid while it is disabled, but a
       message written on a previous submit would still be sitting in its slot when it comes back.
       The summary is left alone: it is rebuilt on every submit, and hiding it here would take
       away the rows that are still true. */
    function reset(element) {
      element.removeAttribute('aria-invalid');

      const slot = document.getElementById(element.id + '-error');
      if (slot) {
        slot.textContent = '';
        slot.hidden = true;
      }

      const hint = document.getElementById(element.id + '-hint');
      if (hint) hint.hidden = false;

      for (let i = 0; i < SHELLS.length; i++) {
        const shell = element.closest('.' + SHELLS[i]);
        if (shell) {
          shell.classList.remove(SHELLS[i] + '--invalid');
          break;
        }
      }
    }

    function controlsIn(scope) {
      return Array.prototype.slice.call(scope.querySelectorAll('input, select, textarea'));
    }

    /* Disabled, not merely hidden: a hidden-but-enabled control is still submitted, still
       validated and still counted by the submit gate. `required` is never touched — it is
       rendered on both halves and is true of both; being disabled is what takes a half out of
       the form. See the section header. */
    function setActive(scope, active) {
      if (!scope) return;
      scope.hidden = !active;
      controlsIn(scope).forEach(function (element) {
        element.disabled = !active;
        if (!active) reset(element);
      });
    }

    function enhance(form) {
      if (enhanced.has(form)) return;
      enhanced.add(form);

      /* `tx-shell` is the common ancestor of the form, the confirmation strip and the eyebrow,
         and it is rendered by this section — so the two elements outside the form are found
         without a document-wide search that a second onboarding form on one page would break. */
      const shell = form.closest('.tx-shell');
      const mode = form.querySelector('[data-onboarding-mode]');
      const selfGroup = form.querySelector('[data-onboarding-self]');
      const othersGroup = form.querySelector('[data-onboarding-others]');
      const selfOption = form.querySelector('[data-onboarding-self-option]');
      const othersOption = form.querySelector('[data-onboarding-others-option]');
      const blocks = Array.prototype.slice.call(form.querySelectorAll('[data-onboarding-student]'));
      /* `button.liquid` takes a class and no data attribute, and the class lands on the button
         itself rather than on a shell around it — unlike `form-input`'s, which is §33's trap. */
      const addButton = form.querySelector('.onboarding__add');
      const fullNote = form.querySelector('[data-onboarding-full]');

      /* How many student blocks are in use. The ceiling is `blocks.length`, which is the Worker's
         `MAX_STUDENTS` rendered — never a second copy of the number. */
      let active = 1;

      function applyStudents() {
        blocks.forEach(function (block, index) {
          setActive(block, index < active);
        });
        if (addButton) addButton.disabled = active >= blocks.length;
        if (fullNote) fullNote.hidden = active < blocks.length;
      }

      function apply() {
        const wantsOthers = Boolean(othersOption && othersOption.checked);
        setActive(selfGroup, !wantsOthers);
        setActive(othersGroup, wantsOthers);
        /* Only once the half is on: `setActive` above has just enabled every control inside it,
           including the blocks nobody has asked for. */
        if (wantsOthers) applyStudents();
      }

      function inputsOf(block) {
        return block.querySelectorAll('input');
      }

      function addStudent() {
        if (active >= blocks.length) return;
        active += 1;
        applyStudents();
        /* The new fields appear below the button that made them, so focus goes to them — without
           it a screen-reader user is told nothing happened. */
        const first = inputsOf(blocks[active - 1])[0];
        if (first) first.focus();
      }

      /* The values shift up and the last block goes dark, so the numbering a reader sees stays
         1, 2, 3 rather than acquiring a hole. The markup never moves — see the section header. */
      function removeStudent(index) {
        if (index < 1 || index >= active) return;

        for (let i = index; i < active - 1; i++) {
          const from = inputsOf(blocks[i + 1]);
          const to = inputsOf(blocks[i]);
          for (let field = 0; field < to.length; field++) {
            to[field].value = from[field] ? from[field].value : '';
          }
        }

        inputsOf(blocks[active - 1]).forEach(function (input) {
          input.value = '';
        });

        active -= 1;
        applyStudents();
        if (addButton) addButton.focus();
      }

      if (attendee()) {
        /* Forced self mode. The self radio stays enabled inside its hidden fieldset, because
           disabling it would drop `purchase_type` from the submission altogether — see the
           section header. */
        if (mode) mode.hidden = true;
        if (selfOption) selfOption.checked = true;
        if (othersOption) othersOption.disabled = true;

        const confirmation = shell ? shell.querySelector('[data-onboarding-confirm]') : null;
        if (confirmation) confirmation.hidden = false;

        const eyebrow = shell ? shell.querySelector('[data-onboarding-eyebrow]') : null;
        if (eyebrow && eyebrow.dataset.onboardingEyebrow) {
          eyebrow.textContent = eyebrow.dataset.onboardingEyebrow;
        }
      }

      /* On the radios, not on the form. `form-submit`'s gate listens for `input` on the form; a
         listener on the control itself runs in the target phase and therefore first. See
         docs/CONVENTIONS.md §10.10. */
      [selfOption, othersOption].forEach(function (option) {
        if (option) option.addEventListener('input', apply);
      });

      if (addButton) {
        addButton.addEventListener('click', addStudent);
      }

      /* Delegated, because nineteen of the twenty remove controls are in the DOM before anyone
         can reach them and a listener each would be nineteen listeners doing nothing. */
      if (othersGroup) {
        othersGroup.addEventListener('click', function (event) {
          const control = event.target.closest('.onboarding__student-remove');
          if (!control) return;
          removeStudent(blocks.indexOf(control.closest('[data-onboarding-student]')));
        });
      }

      /* The success path replaces the form with a panel and never calls `form.reset()`, so this
         is defence rather than a case anyone has seen. A reset puts the radios back to the
         server-rendered `self` and empties the student fields; the count has to follow, or the
         reader is left with empty required blocks nobody asked for. The `reset` event fires
         *before* the controls are reset, so the work is deferred by a turn. */
      form.addEventListener('reset', function () {
        setTimeout(function () {
          active = 1;
          apply();
        }, 0);
      });

      apply();
    }

    function init() {
      document.querySelectorAll('form[data-onboarding]').forEach(enhance);
    }

    init();
    /* The theme editor swaps a section's markup without reloading, which would otherwise leave
       the new form's two halves stuck on whatever the server rendered. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* The three subjects that ask for a town or city instead of an academy — REDESIGN-PLAN.md
       §5.5 and LIQUID.md §6. Handles, never labels: the labels are locale strings and may be
       reworded without anything here changing. */
    const LOCATION_SUBJECTS = ['request-a-location', 'express-your-interest', 'host-an-academy'];

    const enhanced = new WeakSet();

    function control(form, key) {
      const id = form.dataset[key];
      return id ? document.getElementById(id) : null;
    }

    /* Clearing a field on the way out. The control cannot be invalid while it is disabled, but a
       message written on a previous submit would still be sitting in its slot when it comes back.
       The summary is left alone: it is rebuilt on every submit, and hiding it here would take
       away the rows that are still true. */
    function reset(element) {
      element.removeAttribute('aria-invalid');

      const slot = document.getElementById(element.id + '-error');
      if (slot) {
        slot.textContent = '';
        slot.hidden = true;
      }

      const hint = document.getElementById(element.id + '-hint');
      if (hint) hint.hidden = false;

      const shell = element.closest('.input') || element.closest('.select');
      if (shell) shell.classList.remove('input--invalid', 'select--invalid');
    }

    /* Disabled, not merely hidden: a hidden-but-enabled control is still submitted, still
       validated, and still counted by the submit gate. See the section header. */
    function show(element, active, required) {
      if (!element) return;

      element.disabled = !active;
      element.required = Boolean(active && required);
      if (!active) reset(element);

      const field = element.closest('.form-field');
      if (field) field.hidden = !active;
    }

    function apply(form) {
      const subject = control(form, 'contactSubject');
      if (!subject) return;

      const wantsTown = LOCATION_SUBJECTS.indexOf(subject.value) !== -1;
      show(control(form, 'contactTown'), wantsTown, true);
      show(control(form, 'contactAcademy'), !wantsTown, false);
    }

    /* An unrecognised or absent value is left alone, which lands on the `general` option the
       server rendered selected — never an error and never a blank select (REDESIGN-PLAN.md §5.5).
       Matching against the select's own options is what makes that true without a second copy of
       the handle list living here. */
    function preselect(form) {
      const subject = control(form, 'contactSubject');
      if (!subject) return;

      const wanted = new URLSearchParams(window.location.search).get('subject');
      if (!wanted) return;

      const known = Array.prototype.some.call(subject.options, function (option) {
        return option.value === wanted;
      });
      if (known) subject.value = wanted;
    }

    function enhance(form) {
      if (enhanced.has(form)) return;
      enhanced.add(form);

      const subject = control(form, 'contactSubject');
      if (!subject) return;

      /* On the select, not on the form. The select is the target, so this runs before
         form-submit's bubble-phase `input` listener and the gate sees the new `required` state
         rather than the previous one. See the section header. */
      subject.addEventListener('input', function () {
        apply(form);
      });

      /* A successful send calls `form.reset()`, which puts the select back to the option the
         server rendered `selected` — `general` — and would leave a required, empty town field on
         screen underneath it, with the gate holding the button down and no way for the reader to
         see why. Found by sending a real enquiry, not by reading.

         The `reset` event fires *before* the controls are reset, so the work is deferred by a
         turn. Preselect runs again as well: the URL still says what it said on arrival, so the
         form after a send should look the way it did before it. */
      form.addEventListener('reset', function () {
        setTimeout(function () {
          preselect(form);
          apply(form);
        }, 0);
      });

      preselect(form);
      apply(form);
    }

    function init() {
      document.querySelectorAll('form[data-contact-subject]').forEach(enhance);
    }

    init();
    /* The theme editor swaps a section's markup without reloading, which would otherwise leave
       the new form's fifth field stuck on whatever the server rendered. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-system"]) return;
  try {
    
  /* Wiring for the Toast and Dialog specimens. Harness-only: it reads the options off a
     `data-ds-toast` / `data-ds-dialog` attribute and calls the real host, so the page exercises
     the public interface rather than a copy of it. If a trigger does nothing, `window.cohr` is
     missing — which means the hosts are not mounted, and that is the finding. */
  (function () {
    document.querySelectorAll('[data-ds-toast]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const options = JSON.parse(trigger.dataset.dsToast);
        const repeat = parseInt(trigger.dataset.dsRepeat || '1', 10);
        for (let i = 0; i < repeat; i++) {
          window.cohr.toast(
            Object.assign({}, options, {
              message: repeat > 1 ? options.message + ' (' + (i + 1) + ')' : options.message,
              action: options.action
                ? Object.assign({}, options.action, {
                    onClick: function () {
                      window.cohr.toast({ message: 'The action fired.', tone: 'success' });
                    },
                  })
                : undefined,
            })
          );
        }
      });
    });

    document.querySelectorAll('[data-ds-dialog]').forEach(function (trigger) {
      const output = trigger.parentElement.querySelector('[data-ds-dialog-result]');
      trigger.addEventListener('click', function () {
        window.cohr.dialog(JSON.parse(trigger.dataset.dsDialog)).then(function (value) {
          if (output) output.textContent = 'resolved: ' + JSON.stringify(value);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-groups"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq-groups]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-jump]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));

      if (!items.length || !groups.length) return;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      /* Whether the chips are filtering, read off the element rather than from a second copy of
         the breakpoint the stylesheet already owns (docs/CONVENTIONS.md §20.4). */
      function filtering() {
        return getComputedStyle(root).getPropertyValue('--faq-filter').trim() === '1';
      }

      function activate(id, scroll) {
        items.forEach(function (item) {
          var current = item.getAttribute('data-faq-jump') === id;

          item.classList.toggle('is-current', current);

          if (current) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });

        groups.forEach(function (group) {
          group.classList.toggle('is-active', group.id === id);
        });

        if (!scroll) return;

        var target = document.getElementById(id);

        /* `block: 'start'` honours the group's scroll-margin, which is the 96px offset — one
           number, declared once, in the stylesheet. */
        if (target) {
          target.scrollIntoView({
            behavior: reduced.matches ? 'auto' : 'smooth',
            block: 'start',
          });
        }
      }

      /* The filter's stylesheet rule is gated on this attribute, so the groups can only ever be
         hidden once there is something running that can unhide them. */
      root.setAttribute('data-faq-enhanced', '');

      activate(groups[0].id, false);

      items.forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();

          /* In filter mode the answers are replaced where they stand, as MobileFAQ does; scrolling
             would take the chips off the top of the screen and strand the reader. */
          activate(item.getAttribute('data-faq-jump'), !filtering());
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const drawer = document.getElementById('MobileDrawer');
    if (!drawer) return;

    const desktop = window.matchMedia('(width >= 900px)');

    /* Collapse any expanded group as the drawer OPENS, not as it closes.

       This used to hang off the dialog's `close` event, which reads better and does not work:
       Chrome 151 fires `cancel` on an Escape dismissal and never fires `close` at all — proved
       on the dev server on 17 August 2026 with a listener in the page's own world, so it is
       not a devtools or extension artefact. Programmatic `.close()` did not fire it either.
       The drawer therefore reopened with Why COHR? still expanded, which is the one thing the
       reset exists to prevent, and nothing reported it.

       Opening is the path that cannot be skipped: it is the code that puts the drawer on
       screen. Resetting here needs no event to be delivered and states the requirement
       directly — the drawer opens in the same state every time, as `MobileDrawer.jsx` does
       with `setSub(null)`. Do not "tidy" this back onto a close/cancel listener. */
    function open() {
      drawer.querySelectorAll('details[open]').forEach(function (group) {
        group.open = false;
      });
      drawer.showModal();
    }

    function close() {
      drawer.close();
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (control) {
      control.addEventListener('click', open);
    });

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (control) {
      control.addEventListener('click', close);
    });

    /* Rotating a phone into the desktop layout hides the hamburger that opened the drawer.
       Without this the drawer stays over a page whose close affordance has gone. */
    desktop.addEventListener('change', function (event) {
      if (event.matches && drawer.open) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-home-hero-carousel]').forEach(function (root) {
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

      /* Fewer than two panels and there is nowhere to go, so the flag is never set: nothing is
         hidden and no rail is offered. That is also the no-script state, reached from the other
         side. */
      if (panels.length < 2) return;

      var segments = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
      var previous = root.querySelector('.home-hero-carousel__arrow--prev');
      var next = root.querySelector('.home-hero-carousel__arrow--next');
      var index = 0;

      /* The flag the hiding rule and the rail are both gated on — `CONVENTIONS.md` §25.1. */
      root.setAttribute('data-home-hero-carousel-enhanced', '');

      /* 🚨 NO CLOCK. There is no timer, no fill and no `animationend` listener here, and adding
         one would make this the theme's second — `academy-hero-carousel` registers the only one,
         and its header explains why that number is one. The swap is a class toggle with no
         transition, which is also why there is no `prefers-reduced-motion` branch: there is
         nothing moving for it to stop. */
      function show(n) {
        index = (n + panels.length) % panels.length;

        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });

        segments.forEach(function (segment, i) {
          segment.classList.toggle('is-active', i === index);
          if (i === index) {
            segment.setAttribute('aria-current', 'true');
          } else {
            segment.removeAttribute('aria-current');
          }
        });
      }

      segments.forEach(function (segment) {
        segment.addEventListener('click', function () {
          show(parseInt(segment.getAttribute('data-go'), 10) || 0);
        });
      });

      /* Wraps at both ends rather than disabling an arrow, as `academy-hero-carousel` does: an
         arrow that changes meaning as you page is worse than one that always does the same
         thing. With two panels both arrows do the same thing, and that is fine — they still
         always do it. */
      if (previous) {
        previous.addEventListener('click', function () {
          show(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-home-testimonials]').forEach(function (root) {
      var track = root.querySelector('[data-track]');
      var counter = root.querySelector('[data-counter-current]');
      var previous = root.querySelector('.home-testimonials__arrow--prev');
      var next = root.querySelector('.home-testimonials__arrow--next');
      var pages = Array.prototype.slice.call(root.querySelectorAll('[data-page]'));

      /* One page is a row, not a carousel: the section renders no controls for it and there is
         nothing here to wire up. */
      if (!track || !counter || !previous || !next || pages.length < 2) return;

      function offsetOf(page) {
        return page.offsetLeft - track.offsetLeft;
      }

      /* Where the visitor actually is, read off the scroller rather than held in a variable
         this file would then have to keep in step with a swipe. */
      function indexFromScroll() {
        var best = 0;
        var closest = Infinity;

        pages.forEach(function (page, index) {
          var distance = Math.abs(offsetOf(page) - track.scrollLeft);
          if (distance < closest) {
            closest = distance;
            best = index;
          }
        });

        return best;
      }

      function show(index) {
        counter.textContent = index + 1;
      }

      function goTo(index) {
        /* Wraps at both ends, as `HomeScreen.jsx` does. See the header. */
        var page = (index + pages.length) % pages.length;

        track.scrollTo({ left: offsetOf(pages[page]) });

        /* docs/CONVENTIONS.md §14 — written here, from the index we are scrolling TO, rather
           than waiting on the scroll event the smooth scroll will eventually raise. */
        show(page);
      }

      previous.addEventListener('click', function () {
        goTo(indexFromScroll() - 1);
      });

      next.addEventListener('click', function () {
        goTo(indexFromScroll() + 1);
      });

      /* The corrective source, for a swipe or a trackpad. Throttled to a frame because a scroll
         fires far more often than the number can change.

         `offsetParent` is null when the counter is display: none, which is the rail below 750px
         — where the pages have no box either, so their offsets would all read 0. The guard is
         the condition itself rather than a second copy of the breakpoint. */
      var frame = 0;
      track.addEventListener('scroll', function () {
        if (frame || !counter.offsetParent) return;

        frame = requestAnimationFrame(function () {
          frame = 0;
          show(indexFromScroll());
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-location"]) return;
  try {
    
  (function () {
    var API_SRC = 'https://maps.googleapis.com/maps/api/js';
    var ZOOM = 15;

    /* Ported verbatim from the reference project's map module (`assets/theme.js`), which is the
       styling this band exists to keep: desaturate everything, darken it a little, and take the
       water and the roads down further so the type stays the loudest thing on a quiet field. */
    var MAP_STYLES = [
      { elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: -20 }] },
      { elementType: 'labels.text.fill', stylers: [{ saturation: -100 }, { lightness: -10 }] },
      { elementType: 'labels.text.stroke', stylers: [{ saturation: -100 }, { lightness: -20 }] },
      { elementType: 'labels.icon', stylers: [{ saturation: -100 }, { lightness: -20 }] },
      { featureType: 'water', stylers: [{ lightness: -30 }] },
      { featureType: 'road', stylers: [{ lightness: -10 }] }
    ];

    /* Lucide's `map-pin` at its own 24-unit scale — the theme's icon set, so the marker is the
       same glyph a reader meets everywhere else rather than a dot that belongs to no family.
       The second subpath is wound the other way, which punches the hole through the head under
       the default fill rule. The reference project drew a plain circle here; this is the part
       Matt asked to bring into the system. */
    var PIN_PATH = 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z M15 10a3 3 0 1 0-6 0 3 3 0 1 0 6 0Z';
    var PIN_TIP = { x: 12, y: 22 };
    var PIN_SCALE = 1.4;

    var cells = document.querySelectorAll('[data-location-map]');
    if (!cells.length) return;

    /* Google installs a global and cannot be loaded twice, so the first cell to come into view
       fetches the script and everything else waits in this queue. */
    var status = 'idle';
    var waiting = [];

    function token(name) {
      return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    }

    /* Every failure path ends here: no map, no empty frame, one column. */
    function drop(cell) {
      if (cell.parentNode) cell.parentNode.removeChild(cell);
    }

    function loadApi(key) {
      if (status !== 'idle') return;
      status = 'loading';

      window.cohr = window.cohr || {};
      window.cohr.mapsReady = function () {
        status = 'ready';
        var queued = waiting;
        waiting = [];
        queued.forEach(draw);
      };

      var script = document.createElement('script');
      /* The key is a setting, so it is encoded rather than trusted: a stray `&` in it must not
         become another parameter of Google's URL. */
      script.src =
        API_SRC + '?key=' + encodeURIComponent(key) + '&loading=async&callback=cohr.mapsReady';
      script.async = true;
      script.onerror = function () {
        status = 'failed';
        waiting.splice(0).forEach(drop);
      };
      document.head.appendChild(script);
    }

    /* The address is text — "AORA Bristol, Unit 4 …" — so it has to be resolved to a point
       before a map can centre on one. */
    function locate(address) {
      return new Promise(function (resolve, reject) {
        new google.maps.Geocoder().geocode({ address: address }, function (results, state) {
          if (state === 'OK' && results && results.length) {
            resolve(results[0].geometry.location);
          } else {
            reject(state);
          }
        });
      });
    }

    function markerIcon() {
      var gold = token('--gold-accent');
      var edge = token('--white');
      /* No token layer, no painted marker — Google's own pin is a better answer than a colour
         copied out of `tokens.css` into this file (§3). */
      if (!gold || !edge) return null;

      return {
        path: PIN_PATH,
        anchor: new google.maps.Point(PIN_TIP.x, PIN_TIP.y),
        scale: PIN_SCALE,
        fillColor: gold,
        fillOpacity: 1,
        strokeColor: edge,
        /* 1.5px is the theme's icon stroke, and `--icon-weight` is where it is declared. */
        strokeWeight: parseFloat(token('--icon-weight')) || 1.5
      };
    }

    function draw(cell) {
      var address = cell.getAttribute('data-map-address');
      if (!address) return drop(cell);

      locate(address)
        .then(function (position) {
          /* Revealed BEFORE the map is made, not after. A map created inside a `display: none`
             element measures itself as zero by zero and draws as a grey block; giving it its
             size first is the fix, rather than making one in the dark and resizing it after. */
          cell.setAttribute('data-location-map-ready', '');
          var inner = cell.closest('.product-location__inner');
          if (inner) inner.classList.add('product-location__inner--split');

          /* Non-interactive by configuration, exactly as the reference project had it: the map
             is a picture of where the studio is, and a page that scroll-zooms under a reader
             trying to reach the footer is a worse page. */
          var map = new google.maps.Map(cell, {
            zoom: ZOOM,
            center: position,
            styles: MAP_STYLES,
            backgroundColor: 'none',
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            keyboardShortcuts: false
          });

          new google.maps.Marker({ map: map, position: position, icon: markerIcon() });

          /* The row can change height when the copy beside it reflows, and a Google map does not
             notice its own container moving. */
          var recentre = debounce(function () {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(position);
          }, 250);
          window.addEventListener('resize', recentre);
        })
        .catch(function () {
          /* A refused key, an address that resolves to nothing, a network failure — the reader
             is told none of it. The address and "Open in maps" are on the page already. */
          drop(cell);
        });
    }

    function debounce(fn, wait) {
      var timer = 0;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }

    function request(cell) {
      var key = cell.getAttribute('data-map-key');
      if (!key) return drop(cell);

      if (status === 'ready') return draw(cell);
      if (status === 'failed') return drop(cell);
      waiting.push(cell);
      loadApi(key);
    }

    cells.forEach(function (cell) {
      /* Nothing is fetched from Google until the band is close to being read. The observer
         watches the band rather than the cell, because the cell is `display: none` until a map
         is in it and a hidden element never intersects anything. */
      var band = cell.closest('.product-location__inner') || cell;

      if (!('IntersectionObserver' in window)) return request(cell);

      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          request(cell);
        },
        { rootMargin: '200px' }
      );
      observer.observe(band);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
